var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2294 3.99219C11.3214 2.39453 13.6782 2.39453 14.7702 3.9922L15.2021 4.62414C17.9081 8.58336 20.2331 12.79 22.1458 17.1876L22.236 17.3951C22.9101 18.9448 21.8917 20.7045 20.2122 20.8923C15.0865 21.4651 9.91304 21.4651 4.78741 20.8923C3.10787 20.7045 2.0895 18.9448 2.76356 17.3951L2.85377 17.1876C4.7665 12.79 7.09147 8.58335 9.79751 4.62414L10.2294 3.99219ZM13.4998 17.2496C13.4998 16.6973 13.0521 16.2496 12.4998 16.2496C11.9475 16.2496 11.4998 16.6973 11.4998 17.2496C11.4998 17.8018 11.9475 18.2496 12.4998 18.2496C13.0521 18.2496 13.4998 17.8018 13.4998 17.2496ZM12.4998 14.4996C12.914 14.4996 13.2498 14.1638 13.2498 13.7496V8.74956C13.2498 8.33535 12.914 7.99956 12.4998 7.99956C12.0856 7.99956 11.7498 8.33535 11.7498 8.74956V13.7496C11.7498 14.1638 12.0856 14.4996 12.4998 14.4996Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.26e04d078d2646980f67da06a8f9890d.svg";
export { ForwardRef as ReactComponent };